import { render, staticRenderFns } from "./FieldEditor.vue?vue&type=template&id=cb520444"
import script from "./FieldEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FieldEditor.vue?vue&type=style&index=0&id=cb520444&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports